import { render, staticRenderFns } from "./ClientViewIcon.vue?vue&type=template&id=b077cb20&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b077cb20')) {
      api.createRecord('b077cb20', component.options)
    } else {
      api.reload('b077cb20', component.options)
    }
    module.hot.accept("./ClientViewIcon.vue?vue&type=template&id=b077cb20&", function () {
      api.rerender('b077cb20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/assets/icons/ClientViewIcon.vue"
export default component.exports